import { BiImage, BiUndo, BiRedo } from "react-icons/bi";
import { FaSearch, FaPenFancy } from "react-icons/fa";
import { AiOutlineCheckSquare } from "react-icons/ai";
import { BsCardImage, BsPin } from "react-icons/bs";
import { TbBellPlus } from "react-icons/tb";
import { FiUserPlus, FiMoreVertical } from "react-icons/fi";
import { IoColorPaletteOutline } from "react-icons/io5";
import { RiInboxArchiveLine } from "react-icons/ri";
import { useState, useContext, Fragment } from "react";
import { FocusContext } from "../App";
import { useEffect, useRef } from "react";
import {
  doc,
  onSnapshot,
  query,
 orderBy,
  addDoc,
  collection,

  Timestamp,
  getDocs,
} from "firebase/firestore";
import {db } from '../firebase.config'
import { Dialog, Transition } from "@headlessui/react";
const Main = () => {
  const wrapperRef = useRef(null);
  const titleRef = useRef();
  const noteRef = useRef();
  const [focus, setFocus] = useContext(FocusContext);
  const [notes, setNote] = useState([])
  const [isOpen, setIsOpen] = useState(true);
  const [editnote, setEditNote] = useState({})
  const handleFocus = (event) => {
    event.stopPropagation();
    setFocus(true);
    // console.log(focus);
  };

  const docRef = collection(db, "notes");
  const addData = async (newNote) => {
    try {
      const ref = await addDoc(docRef, newNote);
      // console.log(ref)
    } catch (error) { 
      console.log(error)
    }
  
  }

   const getData = async () => {
     const q = query(docRef, orderBy("time", "desc"));
     const querySnapshot = await getDocs(q);
     // console.log(querySnapshot)
     const notes = [];
     querySnapshot.forEach((doc) => {
       // doc.data() is never undefined for query doc snapshots
       // console.log(doc.id, " => ", doc.data());
       notes.push(doc.data());
     });
     setNote(notes);
    //  console.log(notes);
   };
  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          if (!titleRef.current.value && !noteRef.current.value) {
                      setFocus(false);
            return;
          }
//adding to friebase firestore
          const newNote = {
            id: Math.floor(Math.random() * 10000000000000),
            title: titleRef.current.value,
            note: noteRef.current.value,
            time: Timestamp.fromDate(new Date()),
          };
         
          addData(newNote)
getData()
         
          // setNote((prevNote) => {
          //  return [...prevNote, newNote];
          // })
          titleRef.current.value = ''
noteRef.current.value=''
          setFocus(false);
        }

      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);

   
   
  }

   useEffect(() => {
     getData();
   }, []);


  const editNote = (id) => {
    
 const [edit_note]=   notes.filter((note) => {
      return note.id ===id
    
 })

    setEditNote(edit_note)
    setIsOpen(true)
}
  // console.log(notes)
console.log(editnote)
  useOutsideAlerter(wrapperRef);
  return (
    <div>
      <div className="w-screen grid justify-center transition-all duration-200 ease-out ">
        <form
          action=""
          className="w-[40rem] mt-2  shadow-form px-2"
          ref={wrapperRef}
        >
          <div className={` items-center  my-2   ${focus ? "flex" : "hidden"}`}>
            <input
              type="text"
              className="w-[90%] outline-none h-8 pl-3 "
              placeholder="Title"
              ref={titleRef}
            />{" "}
            <BsPin className="text-2xl text-gray-500" />
          </div>
          <div className="flex gap-5 items-center ">
            <input
              type="text"
              placeholder="Take a note"
              className="w-[90%] outline-none h-14 pl-3 py-2  "
              onFocus={handleFocus}
              ref={noteRef}
            />
            <div className="flex gap-14">
              <AiOutlineCheckSquare className="text-2xl text-gray-500" />
              <FaPenFancy className="text-2xl text-gray-500" />
              <BsCardImage className="text-2xl text-gray-500" />
            </div>
          </div>

          <div className={` gap-8 h-10  ${focus ? "flex" : "hidden"}`}>
            <TbBellPlus className="text-[1.5rem] text-gray-500" />
            <FiUserPlus className="text-[1.5rem] text-gray-500" />
            <IoColorPaletteOutline className="text-[1.5rem] text-gray-500" />
            <RiInboxArchiveLine className="text-[1.5rem] text-gray-500" />
            <BsCardImage className="text-[1.5rem] text-gray-500" />
            <FiMoreVertical className="text-[1.5rem] text-gray-500" />
            <BiUndo className="text-[1.5rem] text-gray-500" />
            <BiRedo className="text-[1.5rem] text-gray-500" />
            <button
              className="ml-40"
              onClick={() => setFocus(false)}
              type="button"
            >
              close
            </button>
          </div>
        </form>
      </div>

      <div className=" w-11/12 mx-auto mt-10 flex flex-wrap transition-all ease-in duration-700 gap-10">
        {notes.map((note) => {
          return (
            <div
              className="bg-white border rounded-md p-2 shadow hover:shadow-keep  min-h-[6rem] min-w-[15rem] "
              key={note.id}
              onClick={() => editNote(note.id)}
            >
              <h2 className="font-bold ">{note.title}</h2>
              <p className="">{note.note}</p>
            </div>
          );
        })}
        <Transition show={isOpen} as={Fragment}>
          <Dialog
            open={isOpen}
            onClose={() => setIsOpen(false)}
            className="relative z-50"
          >
            <Transition.Child
              //  show={isOpen}
              as={Fragment}
              enter="ease-out duration-700"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in-out duration-700"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black/50" aria-hidden="true" />
            </Transition.Child>
            <div className="fixed inset-0 flex items-center justify-center p-4">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-700"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-700"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className=" max-w-5/12  bg-white rounded-lg">
                  <form
                    action=""
                    className="w-[40rem] mt-2   px-2"
                    
                  >
                    <div className={` items-center  my-2  flex`}>
                      <input
                        type="text"
                        className="w-[90%] outline-none h-8 pl-3 "
                        placeholder="Title"
                        value={editnote?.title}
                      
                      />{" "}
                      <BsPin className="text-2xl text-gray-500" />
                    </div>
                    <div className="flex gap-5 items-center ">
                      <input
                        type="text"
                        placeholder="Take a note"
                        className="w-[90%] outline-none h-14 pl-3 py-2  "
                        value={editnote?.note}
                      
                      />
                    </div>

                    <div className={` gap-8 h-10   flex`}>
                      <TbBellPlus className="text-[1.5rem] text-gray-500" />
                      <FiUserPlus className="text-[1.5rem] text-gray-500" />
                      <IoColorPaletteOutline className="text-[1.5rem] text-gray-500" />
                      <RiInboxArchiveLine className="text-[1.5rem] text-gray-500" />
                      <BsCardImage className="text-[1.5rem] text-gray-500" />
                      <FiMoreVertical className="text-[1.5rem] text-gray-500" />
                      <BiUndo className="text-[1.5rem] text-gray-500" />
                      <BiRedo className="text-[1.5rem] text-gray-500" />
                      <button
                        className="ml-40"
                        onClick={() => setIsOpen(false)}
                        type="button"
                      >
                        close
                      </button>
                    </div>
                  </form>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition>
      </div>
    </div>
  );
};

export default Main;
